import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

interface IMessageErroFormV2Props extends ComponentProps<"p"> {}

export const MessageErroFormV2 = ({
  className,
  ...rest
}: IMessageErroFormV2Props) => {
  return (
    <p
      {...rest}
      className={twMerge("text-red-500 text-[10px] absolute", className)}
    />
  );
};
